import { NvIconModule } from 'Src/nvps-libraries/design/nv-icon/nv-icon.module';
import { CommonModule } from '@angular/common';
import { PaginatorModule } from './../shared-panel-components/paginator/paginator.module';
import { NvIconButtonModule } from './../../../../nvps-libraries/design/nv-icon-button/nv-icon-button.module';
import { ProfileHeaderComponent } from './profile-header.component';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [ProfileHeaderComponent],
  imports: [NvIconButtonModule, NvIconModule, PaginatorModule, CommonModule],
  exports: [ProfileHeaderComponent],
  providers: [],
})
export class ProfileHeaderModule {}
